/**
 * Guarda atributos del carrito por caja (Personalización caja N) vía /cart/update.js.
 * Pasan al pedido en Admin → detalles adicionales / notas del carrito.
 */
(function () {
  const guarded = new WeakSet();

  function debounce(fn, ms) {
    var t;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, ms);
    };
  }

  function collectBox2goAttrs() {
    var map = {};
    document.querySelectorAll('[data-box2go-cart-attr]').forEach(function (el) {
      var key = el.getAttribute('data-box2go-cart-attr');
      if (key) map[key] = (el.value || '').trim();
    });
    return map;
  }

  function persistBox2goAttrs() {
    return fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var updates = collectBox2goAttrs();
        var attrs = Object.assign({}, cart.attributes || {}, updates);
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attrs }),
        });
      });
  }

  var debouncedPersist = debounce(function () {
    persistBox2goAttrs().catch(function () {});
  }, 450);

  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-box2go-cart-attr]')) {
      debouncedPersist();
    }
  });

  function attachSubmitGuard(form) {
    if (!form || guarded.has(form)) return;
    guarded.add(form);
    form.addEventListener(
      'submit',
      function (e) {
        var hasAttrs = !!form.querySelector('[data-box2go-cart-attr]');
        var needsPkg =
          typeof window.Box2GoPackagingValidateCheckout === 'function' &&
          document.querySelector('[data-box2go-packaging-select]');

        if (!hasAttrs && !needsPkg) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        Promise.resolve()
          .then(function () {
            if (needsPkg) return window.Box2GoPackagingValidateCheckout();
            return true;
          })
          .then(function (pkgOk) {
            if (!pkgOk) return null;
            if (hasAttrs) return persistBox2goAttrs();
            return { ok: true };
          })
          .then(function (res) {
            if (res && res.ok) HTMLFormElement.prototype.submit.call(form);
          })
          .catch(function () {});
      },
      true
    );
  }

  function init() {
    attachSubmitGuard(document.getElementById('cart'));
    attachSubmitGuard(document.getElementById('CartDrawer-Form'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
